import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "socify-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 140, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 140, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 left-4 right-4 z-[70] max-w-md rounded-3xl border border-slate-200 bg-white/90 p-6 shadow-2xl shadow-slate-900/15 backdrop-blur-xl sm:left-6 sm:right-auto"
        >
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FF9F00]/15 text-[#FF9F00]">
              <Cookie className="h-5 w-5" />
            </span>
            <div>
              <p className="font-display text-base font-bold text-slate-900">Unas cookies, ¿sí o no?</p>
              <p className="mt-1 text-sm leading-relaxed text-slate-600">
                Usamos cookies técnicas y de análisis anónimo para mejorar tu experiencia. Lee nuestra{" "}
                <a data-testid="cookie-policy-link" href="/cookies" className="font-bold text-[#1D4ED8] hover:underline">
                  política de cookies
                </a>
                .
              </p>
            </div>
          </div>
          <div className="mt-5 flex gap-3">
            <button
              data-testid="cookie-accept-btn"
              onClick={() => choose("accepted")}
              className="flex-1 rounded-full bg-slate-900 py-3 text-sm font-bold text-white transition-colors hover:bg-[#1D4ED8]"
            >
              Aceptar
            </button>
            <button
              data-testid="cookie-reject-btn"
              onClick={() => choose("rejected")}
              className="flex-1 rounded-full border border-slate-300 py-3 text-sm font-bold text-slate-700 transition-colors hover:border-slate-900 hover:text-slate-900"
            >
              Rechazar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
